<template>
  <v-container id="clientAboutBasic" class="pa-0 pb-5">
    <v-progress-linear class="ma-0" v-if="isAllLoading" indeterminate color="blue"></v-progress-linear>
    <v-card flat max-width="600" class="mx-auto">
      <v-form v-show="!isAllLoading" ref="form" v-model="form.valid">
        <v-list class="pa-2">
          <ClientAboutBasicName
            class="abt-item px-3"
            ref="name"
            :status="getStatus"
            :data="getData"
            @emit="emitted"
          />
          <ClientAboutBasicSex
            class="abt-item px-3"
            ref="sex"
            :status="getStatus"
            :data="getData"
            @emit="emitted"
          />
          <ClientAboutBasicBirthday
            class="abt-item px-3"
            ref="birthday"
            :status="getStatus"
            :data="getData"
            @emit="emitted"
          />
          <ClientAboutBasicMarry
            class="abt-item px-3"
            ref="marry"
            :status="getStatus"
            :data="getData"
            @emit="emitted"
          />
          <ClientAboutBasicNationality
            class="abt-item px-3"
            ref="nationality"
            :status="getStatus"
            :data="getData"
            @emit="emitted"
          />
          <ClientAboutBasicBirthplace
            class="abt-item px-3"
            ref="birthplace"
            :status="getStatus"
            :data="getData"
            @emit="emitted"
          />
          <ClientAboutBasicNotes
            class="abt-item px-3"
            ref="notes"
            :status="getStatus"
            :data="getData"
            @emit="emitted"
          />
          <v-divider class="abt-item px-3"></v-divider>
          <v-subheader class="abt-item px-3">住まい</v-subheader>
          <ClientAboutBasicHome v-for="item in getAddressItems"
            :key="item.id"
            class="abt-item px-3"
            ref="address"
            :status="getStatus"
            :data="item"
            @emit="emitted"
          />
          <ClientAboutBasicHomeInsert
            class="abt-item mb-3 blue--text text--darken-2"
            @emit="emitted"
          />
          <v-divider class="abt-item px-3"></v-divider>
          <v-subheader class="abt-item px-3">連絡先</v-subheader>
          <ClientAboutBasicContact v-for="item in getContactItems"
            :key="item.id"
            class="abt-item px-3"
            ref="contact"
            :status="getStatus"
            :data="item"
            @emit="emitted"
          />
          <ClientAboutBasicContactInsert
            class="abt-item mb-3 blue--text text--darken-2"
            @emit="emitted"
          />
        </v-list>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import ClientAboutBasicName from './components/name'
import ClientAboutBasicSex from './components/sex'
import ClientAboutBasicBirthday from './components/birthday'
import ClientAboutBasicMarry from './components/marry'
import ClientAboutBasicBirthplace from './components/birthplace'
import ClientAboutBasicNationality from './components/nationality'
import ClientAboutBasicNotes from './components/notes'
import ClientAboutBasicHome from './components/home'
import ClientAboutBasicHomeInsert from './components/home/modals/insert'
import ClientAboutBasicContact from './components/contact'
import ClientAboutBasicContactInsert from './components/contact/modals/insert'

const DEFAULT = {
  STATUS: {
    LOADING: 'all',
    EDITING: '',
    SUBMITTING: ''
  },
  FORM: {
    ITEM: {
      DEFAULT: JSON.stringify({
        value: '',
        required: false
      }),
      REQUIRED: JSON.stringify({
        value: '',
        required: true
      })
    }
  }
}
export default {
  name: 'clientAboutBasic',
  components: {
    ClientAboutBasicName,
    ClientAboutBasicSex,
    ClientAboutBasicMarry,
    ClientAboutBasicBirthday,
    ClientAboutBasicBirthplace,
    ClientAboutBasicNationality,
    ClientAboutBasicNotes,
    ClientAboutBasicHome,
    ClientAboutBasicHomeInsert,
    ClientAboutBasicContact,
    ClientAboutBasicContactInsert
  },
  props: [
    'embeded'
  ],
  data () {
    return {
      config: {
        status: {
          loading: DEFAULT.STATUS.LOADING,
          editing: DEFAULT.STATUS.EDITING
        }
      },
      form: {
        valid: true
      },
      store: {
      }
    }
  },
  created () {
  },
  mounted () {
    this.init()
  },
  methods: {
    init: function () {
      this.$nextTick(() => {
        this.get()
      })
    },
    get: function (type) {
      this.$set(this.config.status, 'loading', type != null ? type : 'all')
      this.$emit('emit', {
        action: 'state',
        data: {
          type: 'loading',
          status: true
        }
      })
      this.$firebase.auth().currentUser.getIdToken(true).then(token => {
        this.axios.post(`${this.$url.api}about/get/basic`, {
          cid: this.$route.params.id
        }, {
          headers: {
            'firebase-token': token
          }
        }).then(res => {
          console.log(res)
          this.$set(this.config.status, 'loading', '')
          this.$emit('emit', {
            action: 'state',
            data: {
              type: 'loading',
              status: false
            }
          })
          if (res.data && res.data.success) {
            this.$set(this, 'store', res.data.data)
            this.$emit('update', { type: 'basic' })
          }
        })
      })
    },
    prepare: function () {
      this.$refs.name.prepare()
      this.$refs.sex.prepare()
      this.$refs.birthday.prepare()
      this.$refs.marry.prepare()
      this.$refs.nationality.prepare()
      this.$refs.birthplace.prepare()
      this.$refs.notes.prepare()
      if (this.$refs.address) {
        for (let i = 0; i < this.$refs.address.length; i++) {
          this.$refs.address[i].prepare()
        }
      }
      if (this.$refs.contact) {
        for (let i = 0; i < this.$refs.contact.length; i++) {
          this.$refs.contact[i].prepare()
        }
      }
      this.edit()
    },
    edit: function (req) {
      const { id, type } = req || {}
      if (this.config.status.editing) {
        this.submit({ type: 'series' })
      }
      if (id) {
        this.$set(this.config.status, 'editing', id)
      } else if (type) {
        this.$set(this.config.status, 'editing', type)
      } else {
        this.$set(this.config.status, 'editing', 'all')
      }
      this.$emit('emit', {
        action: 'state',
        data: {
          type: 'editing',
          status: true
        }
      })
    },
    insert: function (req) {
      if (req && req.id) {
        if (req.id.indexOf('addr_') >= 0 && this.store.addresses) {
          this.store.addresses.push(req)
          this.$nextTick(() => {
            if (this.$refs.address.length) {
              this.$refs.address[this.$refs.address.length - 1].prepare()
            }
          })
        } else if (req.id.indexOf('cont_') >= 0 && this.store.contacts) {
          this.store.contacts.push(req)
          this.$nextTick(() => {
            if (this.$refs.contact.length) {
              this.$refs.contact[this.$refs.contact.length - 1].prepare()
            }
          })
        }
      }
    },
    remove: function (req) {
      if (req && req.id) {
        if (req.id.indexOf('addr_') >= 0 && this.store.addresses) {
          let idx = this.store.addresses.findIndex(it => {
            return it.id === req.id
          })
          if (idx >= 0) {
            this.store.addresses.splice(idx, 1)
          }
        } else if (req.id.indexOf('cont_') >= 0 && this.store.contacts) {
          let idx = this.store.contacts.findIndex(it => {
            return it.id === req.id
          })
          if (idx >= 0) {
            this.store.contacts.splice(idx, 1)
          }
        }
      }
    },
    preSubmit: function (req) {
      const { type } = req
      const urls = {
        update: `${this.$url.api}about/update/basic`,
        series: `${this.$url.api}about/update/basic`
      }
      if (this.$refs.form.validate()) {
        let fd = {
          cid: this.$route.params.id,
          addresses: [],
          contacts: []
        }
        if (['name', 'all'].includes(this.config.status.editing)) {
          Object.assign(fd, this.$refs.name.getForm())
        }
        if (['sex', 'all'].includes(this.config.status.editing)) {
          Object.assign(fd, this.$refs.sex.getForm())
        }
        if (['birthday', 'all'].includes(this.config.status.editing)) {
          Object.assign(fd, this.$refs.birthday.getForm())
        }
        if (['marry', 'all'].includes(this.config.status.editing)) {
          Object.assign(fd, this.$refs.marry.getForm())
        }
        if (['nationality', 'all'].includes(this.config.status.editing)) {
          Object.assign(fd, this.$refs.nationality.getForm())
        }
        if (['birthplace', 'all'].includes(this.config.status.editing)) {
          Object.assign(fd, this.$refs.birthplace.getForm())
        }
        if (['notes', 'all'].includes(this.config.status.editing)) {
          Object.assign(fd, this.$refs.notes.getForm())
        }
        if (this.config.status.editing === 'all') {
          if (this.$refs.address && this.$refs.address.length) {
            for (let i = 0; i < this.$refs.address.length; i++) {
              fd.addresses.push(this.$refs.address[i].getForm())
            }
          }
          if (this.$refs.contact && this.$refs.contact.length) {
            for (let i = 0; i < this.$refs.contact.length; i++) {
              fd.contacts.push(this.$refs.contact[i].getForm())
            }
          }
        }
        if (this.config.status.editing.indexOf('addr_') >= 0) {
          let idx = this.$refs.address.findIndex(it => {
            return it.isThisEditing
          })
          if (idx >= 0) {
            fd.addresses.push(this.$refs.address[idx].getForm())
          }
        }
        if (this.config.status.editing.indexOf('cont_') >= 0) {
          let idx = this.$refs.contact.findIndex(it => {
            return it.isThisEditing
          })
          if (idx >= 0) {
            fd.contacts.push(this.$refs.contact[idx].getForm())
          }
        }
        this.$emit('emit', {
          action: 'state',
          data: {
            type: 'loading',
            status: true
          }
        })
        if (type && urls[type]) {
          const url = urls[type]
          return { url, fd, type }
        }
      } else {
        return false
      }
    },
    submit: function (req) {
      const type = (req && req.type) ? req.type : 'update'
      const dt = this.preSubmit({ type })
      if (dt) {
        const { url, fd } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit({ type, fd })
            } else {
              this.failSubmit()
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit()
          })
        })
      }
    },
    postSubmit: function (req) {
      const { type, fd } = req || {}
      const { kana, name } = fd || {}
      if (type !== 'series') {
        this.$set(this.config.status, 'editing', '')
        this.$emit('emit', {
          action: 'state',
          data: {
            type: 'editing',
            status: false
          }
        })
      }
      this.$emit('emit', {
        action: 'state',
        data: {
          type: 'loading',
          status: false
        }
      })
      this.get(this.config.status.editing)
      if (name && name.length) {
        this.$store.commit('client/update', { name })
      }
      if (kana && kana.length) {
        this.$store.commit('client/update', { kana })
      }
    },
    failSubmit: function () {
      this.$set(this.config.status, 'editing', '')
      this.$emit('emit', {
        action: 'state',
        data: {
          type: 'loading',
          status: false
        }
      })
      this.$emit('emit', {
        action: 'state',
        data: {
          type: 'editing',
          status: false
        }
      })
    },
    close: function () {
      this.$set(this.form, 'valid', true)
      this.$set(this.config.status, 'editing', '')
    },
    getStore: function () {
      return this.store
    },
    emitted: function (req) {
      if (
        req &&
        req.action &&
        typeof this[req.action] === 'function'
      ) {
        this[req.action](req.data)
      }
    }
  },
  computed: {
    isEmbeded () {
      return !!(
        this.$props.embeded != null && this.$props.embeded !== false
      )
    },
    isValid () {
      return this.form.valid
    },
    isEditing () {
      return this.config.status.editing
    },
    isAllEditing () {
      return this.config.status.editing === 'all'
    },
    isLoading () {
      return !!this.config.status.loading
    },
    isAllLoading () {
      return this.config.status.loading === 'all'
    },
    getStatus () {
      return this.config.status
    },
    getData () {
      return this.store
    },
    getAddressItems () {
      return (
        this.store.addresses
      ) ? this.store.addresses : []
    },
    getContactItems () {
      return (
        this.store.contacts
      ) ? this.store.contacts : []
    }
  }
}
</script>
